export const messages = {
  en: {
    accessControlInout: {
      search: {
        title: 'Search Conditions',
        machine: 'Please select access control',
        name: 'Please enter user name',
        tel: 'Please enter phone number',
        state: 'Please select open status',
        startTime: 'Please enter start time',
        endTime: 'Please enter end time'
      },
      table: {
        title: 'Access Records',
        face: 'Face',
        id: 'ID',
        machineName: 'Device Name',
        machineCode: 'Device Code',
        userName: 'User Name',
        openType: 'Open Type',
        tel: 'Phone',
        idCard: 'ID Card',
        similar: 'Similarity',
        state: 'Status',
        createTime: 'Open Time'
      },
      openType: {
        all: 'All',
        face: 'Face',
        key: 'Key',
        qrcode: 'QR Code',
        password: 'Password',
        other: 'Other'
      },
      state: {
        all: 'All',
        success: 'Success',
        fail: 'Failed'
      },
      page: {
        title: 'Access Records',
        subtitle: 'Monitor door access events by device, user and open result',
        typeTitle: 'Open Type',
        empty: 'No access records found'
      }
    }
  },
  zh:{
    accessControlInout: {
      search: {
        title: '查询条件',
        machine: '请选择门禁',
        name: '请填写用户名称',
        tel: '请填写手机号',
        state: '请选择开门状态',
        startTime: '请输入开始时间',
        endTime: '请输入结束时间'
      },
      table: {
        title: '进出记录',
        face: '人脸',
        id: '编号',
        machineName: '设备名称',
        machineCode: '设备编码',
        userName: '用户名称',
        openType: '开门方式',
        tel: '手机号',
        idCard: '用户身份证',
        similar: '相似度',
        state: '开门状态',
        createTime: '开门时间'
      },
      openType: {
        all: '全部',
        face: '人脸开门',
        key: '钥匙开门',
        qrcode: '二维码开门',
        password: '密码开门',
        other: '其他'
      },
      state: {
        all: '全部',
        success: '开门成功',
        fail: '开门失败'
      },
      page: {
        title: '门禁进出记录',
        subtitle: '按设备、人员与开门结果监控进出事件',
        typeTitle: '开门方式',
        empty: '暂无进出记录'
      }
    }
  }
}